import 'bootstrap/dist/css/bootstrap.min.css';
import { createGlobalStyle } from 'styled-components';
import bootstrap from './bootstrap';

export default createGlobalStyle`
  body {
    font-size: 14px;
    @media screen {
      background-color: ${props => props.theme.colors.semantic.surface.page};
    }
    font-family: Nunito, 'Nunito Sans', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    display: flex;
  }

  #root {
    width: 100%;
  }

  a {
    &:hover {
      text-decoration: none;
    }
  }

  input,
  select,
  button,
  input:focus,
  select:focus,
  button:focus {
    outline: none;
  }

  button:not(:disabled) {
    cursor: pointer;
  }

  button:disabled {
    cursor: not-allowed;
  }

  li {
    list-style: none;
    margin: none;
  }

  ul {
    margin: none;
  }

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid transparent;
    background-clip: content-box;
    background-color: ${props => props.theme.colors.semantic.border.default};
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: ${props => props.theme.colors.semantic.text.secondary};
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  ${bootstrap}
`;
